import {z} from 'zod';

/**
 * Connection endpoint - references a specific port on a node.
 */
export const connectionEndpointSchema = z.object({
  nodeId: z.string().startsWith('node_'),
  // The port ID (output for source, input for target)
  outputId: z.string().optional(),
  inputId: z.string().optional(),
});

export const sourceEndpointSchema = z.object({
  nodeId: z.string().startsWith('node_'),
  outputId: z.string().min(1),
});

export type SourceEndpoint = z.infer<typeof sourceEndpointSchema>;

export const targetEndpointSchema = z.object({
  nodeId: z.string().startsWith('node_'),
  inputId: z.string().min(1),
});

export type TargetEndpoint = z.infer<typeof targetEndpointSchema>;

export const connectionMetadataSchema = z
  .object({
    label: z.string().optional(),
    sourceData: z.record(z.unknown()).optional(),
  })
  .default({});

export type ConnectionMetadata = z.infer<typeof connectionMetadataSchema>;

export const connectionSchema = z.object({
  id: z.string().startsWith('conn_'),
  source: sourceEndpointSchema,
  target: targetEndpointSchema,
  metadata: connectionMetadataSchema,
});

export type Connection = z.infer<typeof connectionSchema>;
